import { useState, useCallback } from 'react';
import axios from 'axios';
import * as Urls from 'src/constants/EndpointUrls';
import { concatParamsToUrl } from 'src/utils/Http';

export default function useCustomFeaturesAPI() {
  const [isSearching, setIsSearching] = useState(false);
  const [searchResult, setSearchResult] = useState([]);
  const [featuresOps, setFeaturesOps] = useState([]);
  const [isCreating, setIsCreating] = useState(false);

  const search = useCallback(async payload => {
    setIsSearching(true);
    setSearchResult([]);
    setFeaturesOps([]);
    try {
      const res = await axios.post(Urls.DESK_CLIENT_CUSTOM_FEATURES, payload);
      setSearchResult(res.data.clients);
      setFeaturesOps(res.data.featureOptions);
      setIsSearching(false);
    } catch (e) {
      setIsSearching(false);
      console.error('Something went wrong.');
    }
  }, []);

  const create = useCallback(async payload => {
    setIsCreating(true);
    try {
      const res = await axios.put(
        concatParamsToUrl(Urls.DESK_CLIENT_CUSTOM_FEATURES_SHOW, { id: payload.update.clientId }),
        payload
      );
      setIsCreating(false);
      if ([200, 204].includes(res.status) && !isCreating) {
        console.log('Success');
      }
    } catch (e) {
      setIsCreating(false);
      console.error('Something went wrong.');
    }
  }, []);

  return { isSearching, searchResult, featuresOps, search, create, isCreating };
}
